/* eslint-disable quotes */
import classNames from 'classnames'
import {t} from 'i18next'
import {InputText} from 'primereact/inputtext'
import React, {Fragment} from 'react'
import {Controller, useFormContext} from 'react-hook-form'


export interface AddressData {
	onrp?: number
	zip?: number
	city?: number
	street?: string
	streetNumber?: string
}

// new version of postbox that deals with normal addresses
// to be extended with maps autocomplete
export const PostBox = () :JSX.Element => {


	const {control, formState: {errors}} = useFormContext()


	return (
		<>
			<div className="field col-12 md:col-2 mb-2">
						<label
							htmlFor="zip"
							className={classNames({'p-error': errors.postal_code})}>{t<string>('person.zip')}</label>
							<Controller
								name="postal_code" control={control}
								render={({field, fieldState}) => (
									<InputText
										id={field.name}
										{...field}
										value={field.value || ''}
										onChange={e => {
											field.onChange(e)
										}}
										maxLength={10}
										className={classNames({'p-invalid': fieldState.error})}
									/>
								)}/>
					</div>
					<div className="field col-12 md:col-4 mb-2">
						<label
							htmlFor="city"
							className={classNames({'p-error': errors.city})}>{t<string>('person.city')}</label>
							<Controller
								name="city" control={control}
								render={({field, fieldState}) => (
									<InputText
										id={field.name}
										{...field}
										value={field.value || ''}
										maxLength={45}
										onChange={e => {
											field.onChange(e)
										}}
										className={classNames({'p-invalid': fieldState.error})}
									/>
								)}/>
					</div>

					<div className="field col-12 md:col-5 mb-2">
						<label
							htmlFor="street"
							>{t<string>('person.street')}</label>
							<Controller
								name="street" control={control}
								render={({field, fieldState}) => (
									<InputText
										id={field.name}
										{...field}
										value={field.value || ''}
										maxLength={80}
										onChange={e => {
											field.onChange(e)
										}}

									/>
								)}/>
					</div>

					<div className="field col-12 md:col-1 mb-2">
						<label
							htmlFor="street_number"
							>
								{t<string>('person.street_number')}</label>
							<Controller
								name="street_number" control={control}
								render={({field, fieldState}) => (
									<InputText
										id={field.name}
										{...field}
										value={field.value || ''}
										maxLength={20}
										onChange={e => {
											field.onChange(e)
										}}
									/>
								)}/>
					</div>
		</>
	)
}

